module.exports = __webpack_public_path__ + "media/application/images/svgs/check-mark-c2fe420690362dc8f192f852d19feeba.svg";